var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAiStarsBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-stars-big_svg__clip0_5741_14204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.785 37.88v.002a14.756 14.756 0 008.933 9.191l.405.142 8.36 2.784-8.364 2.787h0a14.757 14.757 0 00-9.334 9.337L36 70.485l-2.785-8.366-.142-.405a14.756 14.756 0 00-8.786-8.786l-.405-.142L15.516 50l8.365-2.785v-.001a14.756 14.756 0 009.333-9.332v-.001l2.785-8.367 2.786 8.367zM19.008 11.449v.001a9.562 9.562 0 006.042 6.042l.002.001 3.025 1.008-3.025 1.008a9.535 9.535 0 00-6.044 6.044l-1.009 3.027-1.008-3.027a9.535 9.535 0 00-6.045-6.044h.001L7.921 18.5l3.026-1.008h0a9.534 9.534 0 006.045-6.046h0l1.007-3.026 1.009 3.028zM49.616 4.98v.001a6.946 6.946 0 004.402 4.402v0l.351.118-.351.117-.002.001a6.971 6.971 0 00-4.399 4.399v.001l-.118.352-.116-.352-.001-.002-.14-.38a6.97 6.97 0 00-4.259-4.018h0l-.35-.118.352-.118a6.945 6.945 0 004.262-4.017l.14-.385.114-.344.115.343z",
    stroke: "#DB674B",
    strokeOpacity: 0.32,
    strokeWidth: 3.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-stars-big_svg__clip0_5741_14204"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h72v72H0z"
  })))));
}

export default SvgAiStarsBig;